import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postDataDictionaryExportStart } from '@api';

export const postCoreDataDictionaryExportSlice = createPostAsyncSlice({
	name: 'CoreDataDictionaryExport',
	receive: true,
	request: true,
	requestHandler: postDataDictionaryExportStart
});
